exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form\r\n{\r\n    padding: 15px;\r\n    border: 1px solid #ddd;\r\n}\r\n\r\ntextarea\r\n{\r\n    height: 120px;\r\n}\r\n\r\n.notes\r\n{\r\n    padding: 15px;\r\n}\r\n\r\n.area_message{\r\n    margin-bottom: 5px;\r\n}\r\n.error{\r\n    margin-bottom: 0px;\r\n}\r\nlabel.error {\r\n    color: #ff392d;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/message/message.component.css
// module id = ../../../../../src/app/_components/message/message.component.css
// module chunks = main